import { TTransaction } from "@/api/v1_0";
import { Loader } from "@/components/Loader";
import { NoTransactions } from "@/components/NoTransactions";
import { Dates } from "@/helpers";
import { useStore } from "@/store";
import format from "date-fns/format";
import { ru } from "date-fns/locale";
import parse from "date-fns/parse";
import { observer } from "mobx-react-lite";
import { Children, FunctionComponent, ReactElement, ReactNode } from "react";
import { Title, View } from "./_dependencies";
import { IHistoryProps } from "./types";

export const History: FunctionComponent<IHistoryProps> = observer(
  (props: IHistoryProps): ReactElement<IHistoryProps> => {
    const {
      account,
      loading = false,
      transactions = new Map<TTransaction["uuid"], TTransaction>(),
      ...restProps
    } = props;
    const store = useStore();

    if (loading) {
      return <Loader />;
    }

    if (!transactions || 0 === transactions.size) {
      return <NoTransactions />;
    }

    let firstSection = true;
    let sectionTitle = "";

    return (
      <>
        <Title account={account} />
        {[...transactions.values()].map((transaction) => {
          const processedAt = parse(
            transaction.processedAt,
            "yyyy-MM-dd HH:mm",
            new Date()
          );
          const date = format(processedAt, "ddMMMMyyyy", { locale: ru });
          const children: Array<ReactNode> = [];

          if (sectionTitle !== date) {
            children.push(
              <span
                className="historyDate"
                style={{
                  marginTop: firstSection ? 0 : 20,
                }}
              >
                {Dates.relative(processedAt)}
              </span>
            );

            firstSection = false;
            sectionTitle = date;
          }

          children.push(
            <View
              account={
                transaction.leftUuid === account.uuid
                  ? store.wallet.accounts.get(transaction.rightUuid)!
                  : store.wallet.accounts.get(transaction.leftUuid)!
              }
              transaction={transaction}
            />
          );

          return Children.map(children, (child, childIndex) => (
            <div key={`${transaction.uuid}-${childIndex}`}>{child}</div>
          ));
        })}
      </>
    );
  }
);
